import React from "react";
import { Publish } from "@mui/icons-material";

/**
 * Custom drag an drop component
 * Bijvoorbeeld:

 <DragAndDrop handleDrop={(file) => this.uploadData(rowKey, key, naam, rowProp[0], file[0])}>
    <img
        alt={'afbeelding'}
        src={url}
        width={'50px'}
        height={'5n0px'}
    />
 </DragAndDrop>


 * TODO
 * [] Max file check
 * [] Max file size check
 * [] File type
 * [] Custom upload icon.
 * [] On click open file select popup
 */
class DragAndDrop extends React.Component {
  state = {
    drag: false,
  };

  dragCounter = 0;

  dropRef = React.createRef();

  handleDrag = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  handleDragIn = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.dragCounter++;
    if (e.dataTransfer.items && e.dataTransfer.items.length > 0) {
      this.setState({ drag: true });
    }
  };

  handleDragOut = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.dragCounter--;
    if (this.dragCounter === 0) {
      this.setState({ drag: false });
    }
  };

  handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.setState({ drag: false });
    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      this.props.handleDrop(e.dataTransfer.files);
      e.dataTransfer.clearData();
      this.dragCounter = 0;
    }
  };

  componentDidMount() {
    let div = this.dropRef.current;
    div.addEventListener("dragenter", this.handleDragIn);
    div.addEventListener("dragleave", this.handleDragOut);
    div.addEventListener("dragover", this.handleDrag);
    div.addEventListener("drop", this.handleDrop);
  }

  componentWillUnmount() {
    let div = this.dropRef.current;
    div.removeEventListener("dragenter", this.handleDragIn);
    div.removeEventListener("dragleave", this.handleDragOut);
    div.removeEventListener("dragover", this.handleDrag);
    div.removeEventListener("drop", this.handleDrop);
  }

  render() {
    return (
      <div ref={this.dropRef} style={{ display: "inline-block", position: "relative" }}>
        {this.state.drag ? (
          <div
            style={{
              border: "dashed grey 4px",
              backgroundColor: "rgba(255,255,255,.8)",
              position: "absolute",
              top: 0,
              bottom: 0,
              left: 0,
              right: 0,
              zIndex: 9999,
              width: "100%",
              height: "100%",
            }}
          >
            <div
              style={{
                textAlign: "center",
                color: "grey",
                fontSize: 36,
              }}
            >
              <Publish />
            </div>
          </div>
        ) : null}
        {this.props.children}
      </div>
    );
  }
}
export default DragAndDrop;
